import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api } from '../utils/api';
import './BlogPost.css';

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost]       = useState(null);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getBlogPost(slug)
      .then(data => {
        setPost(data.post || null);
        setLoading(false);
        // Load related posts
        if (data.post?.category) {
          api.getBlogPosts().then(all => {
            setRelated((all.posts || []).filter(p => p.id !== data.post.id && p.category === data.post.category).slice(0,3));
          });
        }
      })
      .catch(() => { setPost(null); setLoading(false); });
  }, [slug]);

  const fmt = d => { try { return new Date(d).toLocaleDateString('en-IN',{day:'numeric',month:'long',year:'numeric'}); } catch { return d; } };

  if (loading) return (
    <div className="blogpost-notfound">
      <div className="container" style={{textAlign:'center',paddingTop:'60px'}}>
        <div className="blog-spinner" style={{margin:'0 auto 16px'}}/>
        <p>Loading...</p>
      </div>
    </div>
  );

  if (!post) return (
    <div className="blogpost-notfound">
      <div className="container">
        <h2>Post not found</h2>
        <p>This article may have been removed or the URL is incorrect.</p>
        <Link to="/blog" className="btn-primary" style={{display:'inline-flex',marginTop:'20px'}}><span>← Back to Blog</span></Link>
      </div>
    </div>
  );

  return (
    <div className="blogpost-page">
      <div className="blogpost-hero">
        <div className="blogpost-hero__glow" />
        <div className="container blogpost-hero__inner">
          <Link to="/blog" className="blogpost-back">← Back to Blog</Link>
          {post.category && <span className="blog-cat-tag">{post.category}</span>}
          <h1>{post.title}</h1>
          <div className="blogpost-meta">
            <span>By {post.author || 'MS Discoveries'}</span>
            <span className="meta-dot">·</span>
            <span>{fmt(post.createdAt)}</span>
            {post.readTime && <><span className="meta-dot">·</span><span>{post.readTime} min read</span></>}
          </div>
        </div>
      </div>
      <div className="container blogpost-body">
        <article className="blogpost-content" dangerouslySetInnerHTML={{ __html: post.content }} />
        {related.length > 0 && (
          <div className="blogpost-related">
            <h3>Related Articles</h3>
            <div className="blogpost-related__grid">
              {related.map(r => (
                <Link to={`/blog/${r.slug}`} key={r.id} className="blog-card">
                  {r.category && <span className="blog-cat-tag">{r.category}</span>}
                  <h3>{r.title}</h3>
                  <p>{r.excerpt}</p>
                  <div className="blog-card__footer">
                    <span className="blog-date">{fmt(r.createdAt)}</span>
                    <span className="blog-arrow">→</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}